export const ID = 'REWARDS';

export const LOAD_CURRENT_REWARDS = `${ID}/LOAD_CURRENT_REWARDS`;
export const LOAD_CURRENT_REWARDS_COMPLETED = `${ID}/LOAD_CURRENT_REWARDS_COMPLETED`;
export const LOAD_CURRENT_REWARDS_FAILED = `${ID}/LOAD_CURRENT_REWARDS_FAILED`;

export const LOAD_HISTORY_REWARDS = `${ID}/LOAD_HISTORY_REWARDS`;
export const LOAD_HISTORY_REWARDS_COMPLETED = `${ID}/LOAD_HISTORY_REWARDS_COMPLETED`;
export const LOAD_HISTORY_REWARDS_FAILED = `${ID}/LOAD_HISTORY_REWARDS_FAILED`;
